import type {SVGProps} from 'react'
const BellIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 1000 1000"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M500 80c-33 0-60 27-60 60v22C316 191 230 306 230 440v170l-80 120v50h700v-50l-80-120V440c0-134-86-249-210-278v-22c0-33-27-60-60-60m0 60c-166 0-210 150-210 300v188l-62 92h544l-62-92V440c0-150-44-300-210-300M400 820c0 55 45 100 100 100s100-45 100-100z"
      clipRule="evenodd"
    />
  </svg>
)
export {BellIcon}
